import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: theme.spacing(1), // 8px
  },
  subheader: {
    marginBottom: theme.spacing(1), // 8px
  },
  subtext: {
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(3), // 24px
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  acceptTermsAndConditionsCheckbox: {
    marginTop: theme.spacing(1),
  },
}));

export default useStyles;
